module.exports = __webpack_public_path__ + "img/courier-ics.4a30e228.svg";